import React, { useState, useEffect } from 'react';
import LegalPageLayout from '../../components/LegalPageLayout/LegalPageLayout';
import { getLegalContent } from '../../services/legalService';

const PrivacyPage: React.FC = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    getLegalContent().then((content) => {
      setMarkdown(content.privacy_markdown ?? '');
    });
  }, []);

  return (
    <LegalPageLayout
      title="Privacy Policy"
      markdown={markdown}
    />
  );
};

export default PrivacyPage;
